export function dbg<T>(args: T): T {
  console.debug(args);
  return args;
}

export const addOptional = (a: number | undefined, b: number) => (a !== undefined ? a + b : a);

export const gizmosVisible = () => process.env.DRAW_GIZMOS === 'true';
